<ng-container *ngIf="!!get">
    <tt-card>
        <tt-select
            class="col-md-3 sp-2"
            ttRememberId="w_accountingallocationbasis.businessco_no"
            ttLabelView="top"
            ttLabel="businessco"
            [(ttModel)]="get.businessco_no"
            (ttModelChange)="onBusinesscoNoChanged()"
            [ttData]="companies"
            ttDataId="businessco_no"
            ttDataName="company_name"
        ></tt-select>

        <tt-checkbox
            class="col-md-3 sp-2"
            ttRememberId="w_accountingallocationbasis.show_details"
            ttLabelView="top"
            ttLabel="show_details"
            [(ttModel)]="get.show_details"
            (ttModelChange)="readGrid()"
        ></tt-checkbox>
        <tt-date-range
            class="col-md-6 sp-2"
            ttRememberId="w_accountingallocationbasis"
            ttLabelView="top"
            ttLabel="date_fom_tom"
            (ttModelChange)="onBusinesscoNoChanged()"
            [(ttStartDate)]="get.date_fom"
            [(ttEndDate)]="get.date_tom"
            [(ttInterval)]="get.dateselector_index"
            (ttModelChange)="readGrid()"
        >
        </tt-date-range>
        <!-- <div class="col-xs-12 sp-0"> -->
        <tt-field-group>
            <tt-select
                *ngIf="get.show_accountingallocation_keyno === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.accountingallocation_keyno"
                ttLabelView="top"
                ttLabel="accountingallocation_name"
                [(ttModel)]="get.accountingallocation_keyno"
                (ttModelChange)="readGrid()"
                [ttData]="accountingAllocations"
                ttDataName="accountingallocation_name"
                ttDataId="accountingallocation_keyno"
                ttShowClearButton
            >
            </tt-select>
            <tt-search-multi-select
                *ngIf="get.show_account_nos === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.account_nos"
                ttModelSetting="object"
                ttLabelView="top"
                ttLabel="account_nos"
                [ttData]="searchAccounts"
                [(ttModel)]="get.account_nos"
                (ttModelChange)="readGrid()"
                ttDataName="item_name"
                ttDataId="item_id"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttId="search" ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </tt-search-multi-select>
            <tt-search-multi-select
                *ngIf="get.show_projects === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.projects"
                ttModelSetting="object"
                ttLabelView="top"
                ttLabel="project_keynos"
                [ttData]="searchProjects"
                [(ttModel)]="get.projects"
                (ttModelChange)="readGrid()"
                ttDataName="item_name"
                ttDataId="item_id"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </tt-search-multi-select>
            <tt-search-multi-select
                *ngIf="get.show_departments === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.departments"
                ttModelSetting="object"
                ttLabelView="top"
                ttLabel="department_ids"
                [ttData]="searchDepartments"
                [(ttModel)]="get.departments"
                (ttModelChange)="readGrid()"
                ttDataName="item_name"
                ttDataId="item_id"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </tt-search-multi-select>
            <tt-search-multi-select
                *ngIf="get.show_equipments === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.equipments"
                ttModelSetting="object"
                ttLabelView="top"
                ttLabel="equipment_ids"
                [ttData]="searchEquipments"
                [(ttModel)]="get.equipments"
                (ttModelChange)="readGrid()"
                ttDataName="item_name"
                ttDataId="item_id"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </tt-search-multi-select>
            <tt-search-multi-select
                *ngIf="get.show_labours === '1'"
                class="col-md-3 sp-2"
                ttRememberId="w_accountingallocationbasis.labours"
                ttModelSetting="object"
                ttLabelView="top"
                ttLabel="labour_nos"
                [ttData]="searchLabours"
                [(ttModel)]="get.labours"
                (ttModelChange)="readGrid()"
                ttDataName="item_name"
                ttDataId="item_id"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </tt-search-multi-select>
            <!-- <tt-input class="col-md-3 sp-2" ttLabel="project_keynos" ttLabelView="top" [(ttModel)]="get.project_keynos"></tt-input> -->
            <!-- <tt-input class="col-md-3 sp-2" ttLabel="department_ids" ttLabelView="top" [(ttModel)]="get.department_ids"></tt-input>
            <tt-input class="col-md-3 sp-2" ttLabel="equipment_ids" ttLabelView="top" [(ttModel)]="get.equipment_ids"></tt-input>
            <tt-input class="col-md-3 sp-2" ttLabel="labour_nos" ttLabelView="top" [(ttModel)]="get.labour_nos"></tt-input> -->
        </tt-field-group>
        <!-- </div> -->
    </tt-card>
    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
